import { GET_ALL_REPORTS_ERROR } from './';

export default error => dispatch => {
  dispatch({ type: GET_ALL_REPORTS_ERROR, payload: { error } });
};
